// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { snjPrimary } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/styles/CommonStyle';
import { listingHeader } from '../views/prop-types';

export const TileHeader = styled.div`
  .store-listing-header {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .title-one {
    span {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      text-transform: capitalize;
    }
  }
  .title-two {
    flex: 1;
    span {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }
  .store-name {
    &--listing {
      text-transform: capitalize;
    }
    &--details {
      margin-top: 0;
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      color: ${(props) => props.theme.colors.TEXT.DARK};
      text-transform: capitalize;
      &-btn {
        font-family: ${(props) => props.theme.fonts.secondaryFontBlackFamily};
        font-weight: ${(props) => props.theme.fonts.fontWeight.black};
        line-height: ${(props) => props.theme.fonts.lineHeight.normal};
        font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
        padding: 0;
        border: 0;
        background: none;
        cursor: pointer;
        outline: inherit;
        text-transform: capitalize;
        text-align: left;
      }
    }
    &--details-new {
      margin-top: 0;
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      color: ${(props) => props.theme.colors.TEXT.DARK};
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      text-transform: capitalize;
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy6}px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      word-wrap: break-word;
      &-btn {
        font-family: ${(props) => props.theme.fonts.secondaryFontBlackFamily};
        font-weight: ${(props) => props.theme.fonts.fontWeight.black};
        line-height: ${(props) => props.theme.fonts.lineHeight.normal};
        font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
        padding: 0;
        border: 0;
        background: none;
        cursor: pointer;
        outline: inherit;
        text-transform: capitalize;
        text-align: left;
      }
    }
  }
`;

export const TileFooter = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.styleProp ? `column` : `row`)};
  align-items: ${(props) => (props.styleProp ? `baseline` : `center`)};
  justify-content: ${(props) => props.isStoreDetailsDesktopRedesignEnabled && 'flex-start'};
  padding-top: ${(props) => {
    if (!props.isStoreDetailsDesktopRedesignEnabled) {
      if (props.variation === 'detail') {
        return props.fromCurrentSelectedStore ? props.theme.spacing.ELEM_SPACING.LRG : 0;
      }
      return props.theme.spacing.ELEM_SPACING.XS;
    }
    return props.variation === 'detail' && 0;
  }};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  margin-top: auto;
`;

export const TileBody = styled.div`
  .address-wrapper {
    @media ${(props) => props.theme.mediaQuery.large} {
      display: ${(props) => (props.variation === 'listing' ? 'flex' : 'block')};
      align-items: center;
    }
  }
  .store-type {
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    &__marker {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
  }

  .address-meta {
    display: ${(props) => (props.variation === 'detail' ? 'flex' : 'block')};
    ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled &&
      `
   margin-bottom: ${props.theme.spacing.ELEM_SPACING.REG};
   `}

    ${(props) =>
      props.isGym &&
      `
 margin-bottom: ${props.theme.spacing.ELEM_SPACING.SM};
 `}
    &__left {
      ${(props) =>
        props.isStoreDetailsDesktopRedesignEnabled &&
        `display: flex;
      align-items: baseline;
      `}

      flex: ${(props) => (props.variation === 'detail' ? 1 : 'none')};
    }
    &__right {
      flex: none;
    }
  }
  .address-meta__nodisplay {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
`;

export const FavStore = styled.div`
  display: flex;
  flex-direction: ${(props) =>
    props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
      ? 'row'
      : 'column'};
  align-items: center;
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  .favorite-store-icon {
    width: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? '16px'
        : '30px'};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
`;

export default css`
  display: flex;
  flex-direction: column;
  box-sizing: bored-box;
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  padding-bottom: ${(props) =>
    !props.isStoreDetailsDesktopRedesignEnabled && props.theme.spacing.ELEM_SPACING.MED};
  border-bottom: ${(props) =>
    !props.isStoreHoursWebEnabled &&
    !props.isStoreDetailsDesktopRedesignEnabled &&
    `1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY}`};

  &.address-tile__selectedStore {
    border: solid 1px ${(props) => props.theme.colorPalette.gray[500]};
    background-color: ${(props) => props.theme.colorPalette.gray[300]};
  }
  .title {
    margin-bottom: 12px;
  }

  .brand-store {
    display: flex;
    align-items: center;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};

    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props.variation === listingHeader ? 'padding-top: 0' : '')};
      ${(props) => (props.variation === listingHeader ? 'height: auto' : '')};
    }

    &__image {
      height: 22px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
    &__text {
      white-space: nowrap;
    }

    ${(props) =>
      (props.variation === listingHeader ||
        props.variation === 'detail' ||
        props.type === 'storelocations') &&
      props.store &&
      !props.store.isGym
        ? `display: none;`
        : ''}
  }

  .address-details {
    font-style: normal;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    margin-right: ${(props) =>
      props.variation === 'listing' ? props.theme.spacing.ELEM_SPACING.XL : 0};
    text-transform: capitalize;
    ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      `
    font-size: ${props.theme.fonts.fontSize.body.bodytext.copy4}px;
    font-weight: ${
      props.type === 'storelocations'
        ? props.theme.fonts.fontWeight.normal
        : props.theme.fonts.fontWeight.medium
    };
    display: flex;
    flex-direction: column;
    padding-bottom: ${
      props.type !== 'storelocations' &&
      props.isStoreDetailsDesktopRedesignEnabled &&
      props.theme.spacing.ELEM_SPACING.LRG
    };
    font-family: ${props.theme.fonts.secondaryFontSemilBoldFamily};
    `}
  }

  .listing-header {
    .title {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
      @media ${(props) => props.theme.mediaQuery.largeOnly} {
        margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
      span {
        margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
      &__one {
        text-transform: capitalize;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      display: flex;
      .heading-left {
        flex: 1;
      }
      .heading-right {
        text-align: right;
        display: flex;
        justify-content: flex-end;
      }
      .address-details {
        padding: 0;
      }
      .store-details-link {
        height: fit-content;
        margin: auto;
      }
    }
    .address-wrapper {
      @media ${(props) => props.theme.mediaQuery.large} {
        ${(props) => (props.variation === listingHeader ? `display: flex;` : '')}
      }
    }
    .address-inline {
      display: none;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        display: block;
      }
    }
    .address-block {
      display: flex;
      flex-direction: column;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        display: none;
      }
    }
  }
  .address-details--listing-header {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: ${(props) =>
        props.variation === listingHeader ? '32px' : props.theme.spacing.ELEM_SPACING.XL};
    }
  }
  .brand-store--sm {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    @media ${(props) => props.theme.mediaQuery.large} {
      display: flex;
      ${(props) => (props.variation === listingHeader ? 'margin-bottom: 0' : '')};
    }
  }

  .heading-right {
    padding-top: 8px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }
  .button-style {
    ${snjPrimary}
  }
  .current-store-tile {
    display: block;
  }
  .store-details-header {
    display: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? 'flex'
        : 'block'};
    justify-content: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      'space-between'};
  }
  .get-directions-link {
    ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      `
  font-weight: ${props.theme.fonts.fontWeight.medium};
  font-size: ${props.theme.fonts.fontSize.body.bodytext.copy4}px;
  line-height: ${props.theme.fonts.fontSize.body.bodytext.copy6}px;
  font-family: ${props.theme.fonts.secondaryFontSemilBoldFamily};
  color: ${props.theme.colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
  text-transform: capitalize;
  letter-spacing:0;
  text-decoration-line: underline;
  vertical-align: super;
  padding-left: 0;
  padding-top: ${props.theme.spacing.ELEM_SPACING.XS_6};
  padding-bottom: ${props.theme.spacing.ELEM_SPACING.MED};
  `}
  }
  .get-directions-link:focus {
    ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      `
    background: none;
    `}
  }

  .phone-number {
    color: ${(props) => props.theme.colors.BLACK};
    text-decoration: none;
    pointer-events: none;
    cursor: default;
    padding-top: ${(props) =>
      props.type !== 'storelocations' ? props.theme.spacing.ELEM_SPACING.XS_6 : 0};
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      color: ${(props) => props.theme.colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
      text-decoration: revert;
      pointer-events: auto;
      cursor: auto;
    }
  }
  .marker-icon {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }
`;

export const StarIcon = styled.div`
  display: inline-block;
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy5}px;
  line-height: 1rem;
  &:before {
    content: '★';
    letter-spacing: 2px;
    background-color: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? props.theme.colors.BLACK
        : props.theme.colors.FAV_ICON_COLOR};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;
